import { Email, TEmailLog } from "@cakemail-org/ui-components-v2"


export type TEmailReportSideBar = {
    tagFilter: any
}

export type TEmailReportInformation = {
    lastLog?: TEmailLog | null
}

export type TEmailReportSmallPreview = {
    email?: Email | null,
}

export enum EEmailReportSmallPreviewView {
    desktop = "desktop",
    mobile = "mobile",
    heatmap = "heatmap",
}
